import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';
import { CardStatusTypes } from '@/types';
import { FC } from 'react';
interface CardTagProps {
    type: CardStatusTypes;
}

const CardTag: FC<CardTagProps> = ({ type }) => {
    const { t } = useTranslation();
    let divClassname = 'py-0.5 px-1 self-start rounded w-max';
    let textClassname = 'text-[10px] font-medium capitalize';

    if (
        type === CardStatusTypes.PURCHASING ||
        type === CardStatusTypes.PURCHASED ||
        type === CardStatusTypes.SUCCESSFUL
    ) {
        divClassname = divClassname + ' bg-primary-25 ';
        textClassname = textClassname + ' text-primary-600 ';
    } else if (type === CardStatusTypes.SCHEDULED) {
        divClassname = divClassname + ' bg-yellow-25 ';
        textClassname = textClassname + ' text-yellow-600 ';
    } else if (
        type === CardStatusTypes.CANCELED ||
        type === CardStatusTypes.RETURNED
    ) {
        divClassname = divClassname + ' bg-error-25 ';
        textClassname = textClassname + ' text-error-600 ';
    } else if (type === CardStatusTypes.RESCHEDULED) {
        divClassname = divClassname + ' bg-orange-25 ';
        textClassname = textClassname + ' text-orange-600 ';
    }

    return (
        <div className={divClassname}>
            <Typography className={textClassname}>{t(type)}</Typography>
        </div>
    );
};
export default CardTag;
